import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { browserHistory } from 'react-router'
import { 
    Toast, Form, FormCell, CellBody, Input, TextArea, Dialog,
    CellsTitle, Button, Toptips
} from 'react-weui'
import { storage, isLZWKAPP } from '../../utils'
import {goBack, updateSuccess} from '../../utils/connectApp'
import { Page, Pay } from '../../components'
import { WKGreenTitle } from '../../components/wk'
import '../../css/page/LiveroomCreatePage.css'


class LiveroomCreateInfoPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            file: '',
            name: '',
            desc: '',
            cover: '',
            isPending: false,
            liveroomId: '',
            isShowSuccessDialog: false,
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
        this.isAnd = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    }
    componentWillUnmount () {
        clearInterval(this.pollingTimer)
    }
    onClickTextArea () {
        if (this.isAnd) {
            setTimeout(() => {
                this.$textarea.scrollIntoView()
            }, 5000)
        }
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    componentDidMount () {
        document.title = '直播间基本信息'
        this.$textarea = document.querySelector('textarea')
        this.fetchData()
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get('/api/liveroom/my')
            .then(res => {
                if (res.data.code === 0) {
                    return location.replace(`/liveroom/${res.data.data.liveroom.id}`)
                }
                return axios.get('/api/liveroom/create/info')
            })
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return location.assign('/liveroom/create/guide')
                }
                this.setState({
                    cover: res.data.data.avatar_url,
                    name: res.data.data.name,
                    desc: res.data.data.description,
                })
            })
            .catch(err => err)
    }
    bindValue (e, filed) {
        this.setState({ [filed]: e.target.value })
    }
    onChangeFile (e) {
        const file = e.target.files[0]
        if (!file) return
        const _this = this
        const reader = new FileReader();
        reader.onload = function(e) {
            _this.setState({ cover: this.result, file })
        }
        reader.readAsDataURL(file);
    }
    getBgClass (cover) {
        return cover ? 'fill' : ''
    }
    onSubmit () {
        const verifyRes = this.verify()
        if (!verifyRes.status) {
            return this.showTip(verifyRes.msg)
        }
        this.setState({ isPending: true })
        const fr = storage.getItem('liveroom_create_fr')
        const inviterId = storage.getItem('liveroom_create_inviter_id')
        const formData = new FormData()
        formData.append('name', this.state.name)
        formData.append('description', this.state.desc)
        formData.append('is_agree', 1)
        formData.append('is_subscribe', +storage.getItem('liveroom_create_is_follow'))
        if (this.state.file) {
            formData.append('avatar', this.state.file)
        } else {
            formData.append('avatar', this.state.cover)
        }
        let queryData = {}
        if (fr) {
            queryData = { fr }
        }
        if (inviterId) {
            queryData = {
                inviter_id: inviterId,
                ...queryData,
            }
        }
        axios.post(`/api/liveroom/create`, formData, {
            params: queryData,
        })
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }

                this.setState({ isPending: true })
                this.polling()
                // 去掉一分钱支付逻辑
                // this.pay(res.data.data.id)
            })
    }
    // 轮询检查是否已经生成直播间，有就跳转直播间
    polling () {
        axios.get('/api/liveroom/my')
            .then(res => {
                if (res.data.code !== 0) {
                    this.pollingTimer = setTimeout(() => {
                        this.polling()
                    }, 500)
                } else {
                    this.setState({ 
                        isPending: false, 
                        liveroomId: res.data.data.liveroom.id,
                        isShowSuccessDialog: true,
                    })
                }
            })
    }
    pay (id) {
        this.props.dispatch({
            type: 'PAY_LIVEROOM',
            payload: {
                params: {
                    product: 'liveroom_creation',
                    liveroom_create_request_id: id,
                },
                success: () => {
                    this.setState({ isPending: true })
                    this.polling()
                }
            }
        })
    }
    verify () {
        if (this.state.file === '' && this.state.cover === '') {
            return { status: false, msg: '请选择直播间头像' }
        }
        if (this.state.name.trim().length > 30 || this.state.name.trim().length < 1) {
            return { status: false, msg: '直播间名称为1-30个字符' }
        }
        return { status: true }
    }
    getIsDisabled () {
        return !((this.state.file || this.state.cover) && this.state.name)
    }
    onClickSuccessDialogOk () {
        this.setState({ isShowSuccessDialog: false })
        if (isLZWKAPP()) {
            updateSuccess({ type: 'liveroom_create' })
            setTimeout(() => {
                goBack()
            }, 1000)
        } else {
            location.assign(`/liveroom/${this.state.liveroomId}`)
        }
    }
    render() {
        return (
            <Page>
                <div className="liveroom-create-page wk-inner-page">
                    <WKGreenTitle
                        title='直播间基本信息'
                    />
                    <div className="upload-wrap">
                        <div className={`weui-uploader__input-box ${this.getBgClass(this.state.cover)}`} style={{backgroundImage: `url(${this.state.cover})`}}>
                            <input type="file" onChange={e => this.onChangeFile(e)} className='weui-uploader__input' />
                        </div>
                        <p className='upload-text'>点击上传直播间头像</p>
                        <p className="upload-subtext">建议尺寸 100px*100px 大小不超过2M</p>
                    </div>

                    <CellsTitle>直播间名称<span className='sub'>（必填，1-30个字符）</span></CellsTitle>
                    <Form>
                        <FormCell>
                            <CellBody>
                                <Input onChange={e => this.bindValue(e, 'name')} value={this.state.name} placeholder="请输入名称" id='profile-name'/>
                            </CellBody>
                        </FormCell>
                    </Form>
                    <CellsTitle>直播间介绍（选填）</CellsTitle>
                    <Form>
                        <FormCell className='textarea'>
                            <CellBody>
                                <TextArea 
                                    onClick={() => this.onClickTextArea()} 
                                    showCounter={false} 
                                    value={this.state.desc} 
                                    onChange={e => this.bindValue(e, 'desc')} 
                                    placeholder="请填写直播间介绍"
                                    rows="4">
                                </TextArea>
                            </CellBody>
                        </FormCell>
                    </Form>
                    <div className="wk-btn-90">
                        <Button onClick={e => this.onSubmit(e)}>
                            立即创建
                        </Button>
                    </div>
                    <p className="intro hide">提示：本次创建所支付的0.01元会返现至个人账户余额</p>
                    <Toast icon="loading" show={this.state.isPending}></Toast>
                    <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                    {/* 创建成功dialog */}
                    <Dialog type="ios" title='' buttons={[{
                        label: '确定', onClick: () => this.onClickSuccessDialogOk()
                    }]} show={this.state.isShowSuccessDialog}>
                        创建成功
                    </Dialog>
                    <Pay />
                </div>
            </Page>
        )
    }
}


export default connect()(LiveroomCreateInfoPage)


// WEBPACK FOOTER //
// ./src/pages/liveroomCreate/LiveroomCreatePage.js